export default "__VITE_ASSET__BKkuqDfa__"